import React, { useState } from "react"
import { makeStyles } from "@material-ui/styles"
import { Carousel } from "react-responsive-carousel"
import HeroBannerSlide from "./heroBannerSlide"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import NavigationArrow from "../../images/navigation arrow.svg"

const useStyles = makeStyles(theme => {
  const button = {
    background: "transparent",
    border: 0,
    margin: 0,
    padding: 0,
    "-webkit-tap-highlight-color": "transparent",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(0, theme.breakpoints.margins.sm),
    },
    [theme.breakpoints.up("md")]: {
      margin: theme.spacing(0, theme.breakpoints.margins.md),
    },
    [theme.breakpoints.up("lg")]: {
      margin: theme.spacing(0, theme.breakpoints.margins.lg),
    },
    [theme.breakpoints.up("xl")]: {
      margin: theme.spacing(0, theme.breakpoints.margins.xl),
    },
    "&::before": {
      backgroundImage: "url(" + NavigationArrow + ")",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      border: 0,
      height: theme.spacing(4),
      margin: 0,
      width: theme.spacing(4),
    },
  }
  return {
    root: {
      position: "relative",
    },
    carousel: {
      //react-responsive-carousel overrides
      "& .carousel": {
        "& .slide": {
          background: "transparent",
        },
        "& .control-dots": {
          padding: 0,
          "& .dot": {
            boxShadow: "none",
            background: theme.palette.green.main,
          },
        },
        "&.carousel-slider": {
          "& .control-arrow": {
            opacity: 0,
            ...button,
            "&.control-prev": {
              paddingRight: theme.spacing(4),
              "&::before": {
                transform: "scaleX(-1)",
              },
            },
            "&.control-next": {
              paddingLeft: theme.spacing(4),
            },
            "&:hover": {
              opacity: 1,
              background: "transparent",
            },
          },
        },
        "& img": {
          pointerEvents: "auto",
          verticalAlign: "initial",
        },
      },
    },
  }
})

export default props => {
  const classes = useStyles()
  const [slide, setSlide] = useState(0)
  const mapDataToSlides = slideData =>
    slideData.map((slide, i) => (
      <HeroBannerSlide
        static={props.static}
        staticImg={props.staticImg}
        webp={props.webp}
        isProductLine={props.isProductLine}
        productPage={props.productPage}
        key={i}
        {...slide}
      />
    ))

  return (
    <div className={classes.root} data-cy="hero">
      <Carousel
        className={classes.carousel}
        onChange={i => {
          setSlide(i)
        }}
        autoPlay
        infiniteLoop={props.slideData.length > 1 ? true : false}
        interval={props.slideData.length > 1 ? 4000 : 0}
        selectedItem={slide}
        showArrows={true}
        showThumbs={false}
        showStatus={false}
        transitionTime={750}
        showIndicators={props.slideData.length > 1 ? true : false}
        useKeyboardArrows
      >
        {mapDataToSlides(props.slideData)}
      </Carousel>
    </div>
  )
}
